module.exports = __webpack_public_path__ + "img/4738eef1a4f568b7242b15fe45d48e58.png";